export default function fuzzySearch (targetString, searchString) {
  const re = new RegExp('.*' + searchString.split('').join('.*') + '.*', 'i')
  return re.test(targetString)
}
